/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var collectedFundsFinishedCreditsColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name',
  width: '110px'
}, {
  name: 'Офис',
  value: 'office_name',
  width: '110px',
  sm: true
}, {
  name: 'Кр. номер',
  render: function render(data) {
    return ___EmotionJSX(Link, {
      "data-value": "data.number",
      to: "credits/details/".concat(data === null || data === void 0 ? void 0 : data.id)
    }, data.number);
  },
  width: '110px'
}, {
  name: 'Кредитоиск.',
  value: 'borrower_name',
  width: '110px',
  sm: true
}, {
  name: 'Главници',
  render: function render(_ref) {
    var total_payed_principal = _ref.total_payed_principal,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_payed_principal"
    }, total_payed_principal, " ", currency);
  },
  md: true
}, {
  name: 'Такси',
  render: function render(_ref2) {
    var total_payed_fees = _ref2.total_payed_fees,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_payed_fees"
    }, total_payed_fees, " ", currency);
  },
  md: true
}, {
  name: 'Лихви',
  render: function render(_ref3) {
    var total_payed_interest = _ref3.total_payed_interest,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_payed_interest"
    }, total_payed_interest, " ", currency);
  },
  md: true
}, {
  name: 'Сума',
  render: function render(_ref4) {
    var total_payed_amount = _ref4.total_payed_amount,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_payed_amount"
    }, total_payed_amount, " ", currency);
  }
}];